var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,4.9l5,5l-4.2,4.2l-5.1-5V4.9H8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,22.1l2.1,2.1l-2,2L10.6,23l-2.1,2.1v0.1c0,1.2-1,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1h0.1 l2.1-2l-3.2-3.2l2-2L9.5,18l13-13.1h4.2v4.3L13.7,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6,27.4c-1.2,0-2.1-0.9-2.1-2.1v-0.1l-4-4.1l5.2-5.2l2,2l-3.2,3.2l2.1,2.1h0.1c1.2,0,2.1,0.9,2.1,2.1 C26.7,26.5,25.8,27.4,24.6,27.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwords);
export default __webpack_public_path__ + "static/media/icon-swords.f880319431f5a34005142473a570f5f8.svg";
export { ForwardRef as ReactComponent };